module.exports = __webpack_public_path__ + "static/media/chess-king-alt.872527e8.svg";